import { render } from "./PopupForm.vue?vue&type=template&id=45f206d3&scoped=true"
import script from "./PopupForm.vue?vue&type=script&lang=js"
export * from "./PopupForm.vue?vue&type=script&lang=js"

import "./PopupForm.vue?vue&type=style&index=0&id=45f206d3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f206d3"]])

export default __exports__